import { createRouter, createWebHistory } from 'vue-router';

const routes =  [
{
  path: '/',
    name: 'Login',
    component: () => import('../views/LoginView.vue'),
  },
  // {
  //   path: '/home',
  //   name: 'Home',
  //   component: () => import('../views/HomeView.vue'),
  // },
  {
    path: '/config',
    name: 'Config',
    component: () => import('../components/ConfigView.vue'),
  },
  {
    path: '/reporte',
    name: 'Reporte',
    component: () => import('../components/ReporteView.vue'),
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: 'active',
})



export default router;